import { Store } from 'libx'
import { observable, action, computed } from 'mobx'
import { validationContext, required, pattern } from 'validx'
import { task } from 'mobx-task'
import path from 'path'

export default class ProfileEditorStore extends Store {
  @observable firstName = ''
  @observable lastName = ''
  @observable email = ''

  validation = validationContext(this, {
    firstName: [required('First name is required')],
    lastName: [required('Last name is required')],
    email: [required('Email is required'), pattern({ pattern: 'email', msg: 'Not a valid email' })]
  })

  @computed get canSetEmail () {
    // Can only set the email if we don't already have it.
    // return !this.rootStore.authStore.user.email
    return true
  }

  @computed get picture () {
    return this.rootStore.authStore.user.avatar
  }

  @action activate () {
    const user = this.rootStore.authStore.user
    this.validation.reset()
    Object.assign(this, {
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email
    })
  }

  @task.resolved async save () {
    if (!this.validation.reset().validate().isValid) {
      return
    }

    const data = {
      given_name: this.firstName,
      family_name: this.lastName,
      email_address: this.email
    }
    await this.rootStore.api.profiles.patch('me', data).then(action(this.rootStore.userStore.users.set))
      .then(action(() => {
        this.rootStore.flashMessageStore.create({
          type: 'success',
          message: 'Your profile has been updated!'
        }).autoDismiss()
      }))
  }

  @task.resolved async uploadPicture (file) {
    const maxSize = 1024 * 1024 * 2 // 2mb
    const ext = path.extname(file.name)
    const isSupported = /(jpe?g|png)/i.test(ext)
    if (!isSupported) {
      this.rootStore.flashMessageStore.create({
        type: 'error',
        message: 'We only support PNG, JPEG and JPG files for profile picture.'
      }).autoDismiss()
      return
    }

    if (maxSize < file.size) {
      this.rootStore.flashMessageStore.create({
        type: 'error',
        message: `Max image size is 2mb.`
      }).autoDismiss()
      return
    }
    const msg = this.rootStore.flashMessageStore.create({
      inProgress: true,
      message: 'Uploading new profile picture...'
    })
    await this.rootStore.api.profiles.uploadPicture(file)
      .then(action(this.rootStore.userStore.users.set))
      .then(action(() => {
        msg.done('Successfully changed your profile picture!').autoDismiss()
      }))
      .catch(action(err => {
        msg.failed(err.message)
        console.error(err)
      }))
  }
}



// WEBPACK FOOTER //
// ./src/client/store/ui/ProfileEditorStore.js